import React from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
  <header className="min-h-screen flex items-center pt-32 px-4 sm:px-6">
      <div className="w-full max-w-7xl mx-auto grid lg:grid-cols-2 gap-6 lg:gap-12 items-start">

        {/* Left Text */}
        <div className="order-2 lg:order-1">
          <div className="w-full max-w-3xl mx-auto lg:mx-0 lg:ml-auto mb-6">
            <div className="rounded-2xl border-[3px] border-goldSoft bg-gradient-to-br from-bone via-white to-sand/50 p-2 sm:p-2.5 shadow-[0_12px_40px_-12px_rgba(26,31,54,0.28)]">
              <div className="relative flex h-[24rem] sm:h-[28rem] lg:h-[34rem] w-full items-center justify-center overflow-hidden rounded-xl bg-white/50 ring-1 ring-goldSoft/25">
                <img
                  src="/preeti-kagna-award.jpeg"
                  alt="Preeti — award recognition"
                  className="block h-full w-auto max-w-none shrink-0 object-contain object-center"
                />
              </div>
            </div>
          </div>

          <h1 className="text-indigoDeep text-xl sm:text-2xl lg:text-3xl leading-tight mb-4 text-center lg:text-left" style={{fontFamily: '"Rubik", sans-serif'}}>
              Why Mova Astro?
          </h1>

          <p className="text-grayWarm text-sm sm:text-base lg:text-lg w-full mb-6 text-center lg:text-left">
            The knowingness embedded in this gift is explicitly not designed for superstitious fortune-telling. Vedic Astrology or Jyotish is an ancient art and science taught by the enlightened sages that swiftly reveals our talents and challenges.
          </p>

          <blockquote className="text-indigoDeep text-sm sm:text-base lg:text-lg italic mb-6 pl-4 text-center lg:text-left">
            "Where ancient wisdom shapes your path forward."
          </blockquote>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-center lg:items-start">
            <Link
              to="/booking"
              className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-goldSoft text-indigoDeep font-semibold rounded-md shadow-gold hover:bg-goldHover text-center text-sm sm:text-base inline-block"
            >
              Book Your Reading
            </Link>
          </div>

          {/* WhatsApp Section */}
          <div className="flex items-center justify-center lg:justify-start gap-3 mt-6 p-4 bg-white/80 rounded-lg border border-goldSoft/30">
            <svg className="w-8 h-8 text-green-500" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516"/>
            </svg>
            <div className="text-center lg:text-left">
              <a 
                href="https://wa.me/919259806072" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-green-600 hover:text-green-700 text-sm font-semibold underline"
              >
                Ping us on WhatsApp for booking
              </a>
            </div>
          </div>
        </div>

        {/* Right Content — same card width as intro; hug gutter so both images align */}
        <div className="order-1 lg:order-2 w-full flex justify-center lg:justify-start">
          <div className="w-full max-w-3xl mx-auto lg:mx-0 lg:mr-auto">
            <div className="rounded-2xl border-[3px] border-goldSoft bg-gradient-to-br from-bone via-white to-sand/50 p-2 sm:p-2.5 shadow-[0_12px_40px_-12px_rgba(26,31,54,0.28)]">
              <div className="relative flex h-[24rem] sm:h-[28rem] lg:h-[34rem] w-full items-center justify-center overflow-hidden rounded-xl bg-white/50 ring-1 ring-goldSoft/25">
                <img
                  src="/ganesha.png"
                  alt="Ganesha"
                  className="block h-full w-auto max-w-none shrink-0 object-contain object-center"
                />
              </div>
            </div>
          </div>
        </div>

      </div>
    </header>
  );
}